

const maxFiles = 10;

export const fileUploader = (uploadMutationFn, extTypes, queryObject = {}, multiple = false) => () => {
    if (!uploadMutationFn) {
        console.error('uploadMutationFn not provided');
        return;
    }


    const fileInput = document.createElement('input');
    fileInput.style.opacity = 0;
    fileInput.type = 'file';
    fileInput.accept = extTypes;
    fileInput.multiple = multiple;

    fileInput.onchange = (e) => {
        const files = e.target.files;

        if (files.length > maxFiles) {
            console.log('Maximum number of files exceeded',files.length);
            return;
        } else if (files.length > 0) {
            const formData = new FormData();
            Array.from(files).forEach((file) => {
                formData.append('files', file, file.name); // Append each file
            });

            uploadMutationFn.mutate({ formData, ...queryObject });
        }
    };
    fileInput.click();
};
